import authenticated from '../http-clients/authenticated'

export default{
  index({tenantId, topicId}){
    return authenticated({
      url: `/tenants/${tenantId}/topics/${topicId}/kc`,
      method: 'get'
    })
  },
  show({tenantId, topicId, knowledgecheckId}){
    return authenticated({
      url: `/tenants/${tenantId}/topics/${topicId}/kc/${knowledgecheckId}`,
      method: 'get'
    })
  },
  store({tenantId, topicId, data}){
    return authenticated({
      url: `/tenants/${tenantId}/topics/${topicId}/kc`,
      method: 'post',
      data
    })
  },
  update({tenantId, topicId, knowledgecheckId, data}){
    return authenticated({
      url: `/tenants/${tenantId}/topics/${topicId}/kc/${knowledgecheckId}`,
      method: 'put',
      data
    })
  },
  destroy({tenantId, topicId, knowledgecheckId}){
    return authenticated({
      url: `/tenants/${tenantId}/topics/${topicId}/kc/${knowledgecheckId}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/knowledgechecks/topic-knowledgecheck.js